import { FC } from 'react';
import { useFragment } from 'react-relay';
import graphql from 'babel-plugin-relay/macro';

import Link from '@mui/material/Link';
import EntityTableRow, { EntityTableRowProps } from 'components/EntityTableRow';
import TableCell from 'components/TableCell';

import { CityRow_city$key } from '__generated__/CityRow_city.graphql';

type Props = EntityTableRowProps & {
  city: CityRow_city$key;
};

const CityRow: FC<Props> = ({ city, ...props }) => {
  const cityData = useFragment(
    graphql`
      fragment CityRow_city on City {
        id
        name

        ...EntityTableRow_entity
      }
    `,
    city
  );

  const { id, name } = cityData;

  return (
    <EntityTableRow entity={cityData} {...props}>
      <TableCell>
        <Link href={`/settings/cities/${id}`}>{name}</Link>
      </TableCell>
    </EntityTableRow>
  );
};

export default CityRow;
